<template>
  <div class="sbd__studio">
    <a :href="storeLink" class="sbd__studio-img-wrapper">
      <ImageField 
        class="sbd__studio-img"
        :obj="{'url':studioImage,'alt':'Store Image','width':608,'height':608}" 
      />
    </a>
    <div class="sbd__studio-copy">
      <span class="sbd__studio-name">{{studio.name}}</span>
      <span class="sbd__studio-address">
        {{studio.address_line_1}} {{studio.city}}, {{studio.state}} {{studio.postal_code}}
      </span>
      <a :href="`tel:${studio.phone}`" class="sbd__studio-phn">{{studio.phone}}</a>
      <div class="sbd__studio-btns">
        <a :href="storeLink" class="sbd__studio-btn">View Store</a>
        <a :href="directionLink" target="_blank" class="sbd__studio-btn">Get Directions</a>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, toRefs, ref } from 'vue';
  import ImageField from '../../global/image.vue'

  const props = defineProps({
    studio: {
      type: Array,
      required: true,
    }
  })

  const { studio } = toRefs(props)
  const defualtImage = ref('https://images.prismic.io/stio/46bc2d92-060c-4eb8-8954-4132f3d84f36_Stio-Logo-663x439.jpg?auto=compress,format')
  
  const studioImage = computed(() => {
    if(studio.value.custom_fields.length){
      let data = studio.value.custom_fields.filter(field => field.name === 'Store Image')
      return data.length ? data[0].value : defualtImage
    }else{
      return defualtImage;
    }
  })

  const storeLink = computed(() => {
    if(studio.value.custom_fields.length){
      let data = studio.value.custom_fields.filter(field => field.name === 'View Store')
      return data.length ? data[0].value : '/'
    }else{
      return '/';
    }
  })

  const directionLink = computed(() => {
    if(studio.value.custom_fields.length){
      let data = studio.value.custom_fields.filter(field => field.name === 'Direction Link')
      return data.length ? data[0].value : '/'
    }else{
      return '/';
    }
  })
</script>